import { Box, Text } from '@hopskipdrive/react-components';

import { Button } from '../Button';
import { variables } from '../variables';

import { retryButtonSx } from './QueryErrorState.styles';

export interface QueryErrorStateProps {
  message: string;
  tableHeightOffset: number;
  onRetry?: () => void;
}

export const QueryErrorState = ({ message, tableHeightOffset, onRetry }: QueryErrorStateProps) => {
  const minHeight = window.innerHeight - tableHeightOffset - variables.tableHeadHeight;

  return (
    <Box
      role="alert"
      aria-live="polite"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="16px"
      minHeight={minHeight}
    >
      <Text textColor="secondaryText" textAlign="center">
        {message}
      </Text>
      {onRetry && (
        <Button color="tertiary" onClick={onRetry} sx={retryButtonSx}>
          Try again
        </Button>
      )}
    </Box>
  );
};
